import { analytics } from '@eti/utils';
import { useProperty, useSiteContext } from '@eti/providers';
import { useEffect, useRef } from 'react';
import { buildResponsivePageViewEvent } from '../buildResponsivePageViewEvent';
import type { GA4PageViewParamsType } from '../buildResponsivePageViewEvent';

export const useGA4PageViewEvent = (params: GA4PageViewParamsType, isReady = true) => {
  const { p } = useProperty();
  const { brand, entryType, market, partner, siteName } = useSiteContext();
  const fired = useRef(false);
  const paramsRef = useRef(params);
  paramsRef.current = params;

  useEffect(() => {
    if (isReady && p('IbeClient.GA4.Enabled') && !fired.current) {
      const siteDefaults: Partial<GA4PageViewParamsType> = {
        brand: brand?.code ?? undefined,
        entry_type: entryType ?? undefined,
        entry_type_domain: partner ?? undefined,
        site_country: market?.code ?? undefined,
        site_name: siteName ?? undefined,
      };
      analytics.pushEntryToDataLayer(
        buildResponsivePageViewEvent({ ...siteDefaults, ...paramsRef.current }),
      );
      fired.current = true;
    }
  }, [isReady, p, brand?.code, entryType, market?.code, partner, siteName]);
};
